import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const onBindDocs = async (value) => {
  return await request.post(
    '/Docs/bind',
    value,
    'При связывание документа произошла ошибка',
    'Error'
  );
};

const useDocsBind = () => {
  const mutation = useMutation(onBindDocs, {
    onSuccess: async (data, { documentId, bindEntityId }) => {
      if (data === 'Error') return;

      console.log(documentId, bindEntityId, 'documentId, bindEntityId');
    },
  });

  return {
    isLoading: mutation.isLoading,
    onBindDocs: mutation.mutateAsync,
  };
};

export default useDocsBind;
